export default {
  "userAdminTable.email": "Email Address",
  "userAdminTable.name": "Name",
  "userAdminTable.mobile": "Mobile no.",
  "userAdminTable.role": "Role",
  "userAdminTable.maxLimit": "You have {curr}/{max} registered users. {contactUs} to purchase additional user licences.",
};
